var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('ot-loading',{class:_vm.$style.loading,attrs:{"type":"push","size":"big","label":"2O3T Loading"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }